import React from 'react'

function Setting() {
  return (
    <div className='py-[28px]'>Setting</div>
  )
}

export default Setting